const TYPES = {
  DEVICE_IS_PC: 'DEVICE_IS_PC',
}

export default TYPES